import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SmartImage from '../ui/SmartImage';
import MediaSkeleton from '../ui/MediaSkeleton';

function Card({ article }) {
    const publishedDate = article.published_date
        ? new Date(article.published_date).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })
        : '-';

    return (
        <article className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_16px_40px_rgba(15,23,42,0.08)] transition hover:-translate-y-1 hover:shadow-[0_22px_50px_rgba(15,23,42,0.13)]">
            <SmartImage
                src={article.image_urls?.[0] || '/default-thumbnail.jpg'}
                alt={article.title}
                wrapperClassName="h-48 w-full bg-slate-200"
                className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.03]"
            />
            <div className="p-5">
                <div className="mb-3 flex items-center justify-between gap-2">
                    <span className="text-[10px] font-bold uppercase tracking-wider text-blue-600">{article.jenis || 'Media'}</span>
                    <span className="text-xs text-slate-400">{publishedDate}</span>
                </div>
                <Link to={`/media/${article.jenis}/${article.slug}`} className="block">
                    <h2 className="line-clamp-2 min-h-[3rem] text-base font-bold leading-6 text-slate-950 transition group-hover:text-blue-700">{article.title}</h2>
                    <p className="mt-3 line-clamp-3 text-sm leading-6 text-slate-500">{article.description || 'Konten tidak tersedia.'}</p>
                </Link>
                <Link to={`/media/${article.jenis}/${article.slug}`} className="mt-5 inline-flex items-center gap-2 rounded-full bg-slate-950 px-4 py-2 text-xs font-semibold text-white transition hover:bg-blue-700">Selengkapnya <span aria-hidden="true">&rarr;</span></Link>
            </div>
        </article>
    );
}

function MediaCard() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();
        fetch(`${process.env.REACT_APP_BACKEND_URL}/articles/featured`, { signal: controller.signal })
            .then((response) => response.json())
            .then((data) => {
                const sorted = (Array.isArray(data.data) ? data.data : [])
                    .sort((a, b) => new Date(b.published_date) - new Date(a.published_date))
                    .slice(0, 4);
                setArticles(sorted);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') console.error('Error fetching articles:', error);
            })
            .finally(() => setLoading(false));
        return () => controller.abort();
    }, []);

    return (
        <section className="relative overflow-hidden py-16">
            <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('assets-web/hero_banner_3.png')", backgroundAttachment: 'fixed' }} />
            <div className="absolute inset-0 bg-slate-950/80" />
            <div className="container relative z-10 mx-auto px-4">
                <div className="mb-8">
                    <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-300">Media Terbaru</span>
                    <h2 className="mt-2 text-3xl font-bold text-white">Berita & Artikel Pilihan</h2>
                </div>
                {loading ? (
                    <MediaSkeleton count={4} compact />
                ) : (
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                        {articles.map((article) => <Card key={article.id} article={article} />)}
                    </div>
                )}
            </div>
        </section>
    );
}

export default MediaCard;
